module.exports = new __parcel__URL__("error-triangle-basic-darkmode.aa5ef22c.svg").toString();